export enum MediaAPI
{
    UPLOAD_IMAGE                =   "upload/image"                  ,
    UPLOAD_VIDEO                =   "upload/video"                  ,
    UPLOAD_LEVEL_IMAGE          =   "upload/{level}/{levelId}"      ,
    GET_MEDIA_BY_UUID           =   "getby/uuid/{uuid}"             ,
    GET_DATA_BY_LEVEL           =   "get/data"                      ,
    GET_FILE_BY_LEVEL           =   "get/file"                      ,

    DELETE_BY_TYPE              =   "delete/by/typecode"            ,

}